'use client';

import NavigationMenuStateProvider from '@/context/NavigationProvider';
import {isUnauthenticated, signedInPaths} from '@/utils/session-utils';
import {SessionProvider, useSession} from 'next-auth/react';
import {usePathname, useRouter} from 'next/navigation';
import {useEffect} from 'react';

export function Providers({children}: {children: React.ReactNode}) {
  return (
    <SessionProvider>
      <AuthProvider>{children}</AuthProvider>
    </SessionProvider>
  );
}

// This component is used to redirect users to the signout page if they are unauthenticated and
// trying to access pages that require authentication. It should prevent them from navigating
// to an authenticated page immediately after signout.
function AuthProvider({children}: {children: React.ReactNode}) {
  return <AuthProviderImpl>{children}</AuthProviderImpl>;
}

function AuthProviderImpl({children}: {children: React.ReactNode}) {
  const {data: session} = useSession();
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    if (session === undefined) return;

    if (session === null || isUnauthenticated(session)) {
      if (signedInPaths.includes(pathname)) {
        router.push('/signout');
      }
    }
  }, [session, pathname, router]);

  return <NavigationMenuStateProvider>{children}</NavigationMenuStateProvider>;
}
